import React, { Component, Fragment } from "react";
// Components Imports
import ContextMenuItems from "../../ContextMenuItems";
import TextComponent from "../CustomGridTypeComponents/TextComponent";
import SingleSelectComponent from "../CustomGridTypeComponents/SingleSelectComponent";
import DateSelectComponent from "../CustomGridTypeComponents/DateSelectComponent";
import NumberComponent from "../CustomGridTypeComponents/NumberComponent";
import PercentComponent from "../CustomGridTypeComponents/PercentComponent";
import CurrencyComponent from "../CustomGridTypeComponents/CurrencyComponent";

export default class RowRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: {
        visible: false,
        x: 0,
        y: 0,
      },
    };
  }

  onRowHandle = (event, rowRecord, cellRecord, groupMeta, groupLength) => {
    event.preventDefault();
    const that = this;
    that.setState({
      popup: {
        rowRecord,
        visible: true,
        // eslint-disable-next-line no-restricted-globals
        x: event.clientX,
        // eslint-disable-next-line no-restricted-globals
        y: event.clientY,
      },
    });
    /* That co is for => Recognize the selected Menu Item with close menu */
    document.addEventListener(`click`, function onClickInside(e) {
      console.debug("INTSIDE", that.state, e.srcElement.id);
      that.setState({ popup: { visible: false } });
      that.addMenuListeners(e, rowRecord, cellRecord, groupMeta, groupLength);
      document.removeEventListener(`click`, onClickInside);
    });
    console.debug("hi", event, rowRecord);
  };

  addMenuListeners = (e, rowRecord, cellRecord, groupMeta, groupLength) => {
    console.debug("addMenuListeners", e, rowRecord, cellRecord);
    // eslint-disable-next-line default-case
    switch (e.srcElement.id) {
      case "Delete":
        this.props.deleteRow(rowRecord, groupMeta, groupLength);
        break;
      case "Autosize":
        this.props.autosizeColumns();
        break;
      case "Reset":
        this.props.resetColumns();
        break;
      case "Copy":
        this.onCopyText(cellRecord);
        break;
    }
  };

  onCopyText = cellRecord => {
    const copyText = document.getElementById(cellRecord);
    console.debug("copyTextcopyTextcopyText", copyText);
    if (copyText !== null) {
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
    }
  };

  // eslint-disable-next-line consistent-return
  applyStyle = col => {
    if (col.hidden) {
      return { display: "none" };
    }
  };

  getclassName = (col, row) => {
    let editableClass = "revv-divtablecell";
    if (
      row.rowData[col.field] &&
      row.rowData[col.field].cellMeta &&
      row.rowData[col.field].cellMeta.editable
    ) {
      editableClass += " editable-col-td";
    }
    if (
      row.rowData[col.field] &&
      row.rowData[col.field].cellMeta &&
      row.rowData[col.field].cellMeta.isPopUp
    ) {
      editableClass += " editable-col-td";
    }
    return editableClass;
  };

  renderSwitch = (col, row, rowIndex, colIndex, groupMeta, groupLength) => {
    console.debug(
      "COLUMN GRID",
      col,
      row,
      rowIndex,
      colIndex,
      groupMeta,
      groupLength,
    );
    const self = this;
    switch (col.type) {
      case "TEXT_FIELD":
        return (
          <div
            onContextMenu={event =>
              self.onRowHandle(
                event,
                row,
                row.rowData[col.field].cellData,
                groupMeta,
                groupLength,
              )
            }
            className={this.getclassName(col, row)}
            style={this.applyStyle(col)}>
            <TextComponent
              id={row.rowData[col.field] ? row.rowData[col.field].cellData : ""}
              value={
                row.rowData[col.field] ? row.rowData[col.field].cellData : ""
              }
              editable={
                row.rowData[col.field] &&
                row.rowData[col.field].cellMeta &&
                row.rowData[col.field].cellMeta.editable
              }
              onBlurData={value =>
                self.props.onCellValueChanged(value, col, row, rowIndex)
              }
            />
          </div>
        );
      case "NUMBER_FIELD":
        return (
          <div
            onContextMenu={event =>
              self.onRowHandle(
                event,
                row,
                row.rowData[col.field].cellData,
                groupMeta,
                groupLength,
              )
            }
            className={this.getclassName(col, row)}
            style={this.applyStyle(col)}>
            <NumberComponent
              id={row.rowData[col.field] ? row.rowData[col.field].cellData : ""}
              value={
                row.rowData[col.field] ? row.rowData[col.field].cellData : ""
              }
              editable={
                row.rowData[col.field] &&
                row.rowData[col.field].cellMeta &&
                row.rowData[col.field].cellMeta.editable
              }
              isPopUp={
                row.rowData[col.field] &&
                row.rowData[col.field].cellMeta &&
                row.rowData[col.field].cellMeta.isPopUp
              }
              openPopup={value =>
                this.props.openPopup(value, col, row, colIndex)
              }
              onBlurData={value =>
                self.props.onCellValueChanged(value, col, row, rowIndex)
              }
            />
          </div>
        );
      case "PERCENTAGE_FIELD":
        return (
          <div
            onContextMenu={event =>
              self.onRowHandle(
                event,
                row,
                row.rowData[col.field].cellData,
                groupMeta,
                groupLength,
              )
            }
            className={this.getclassName(col, row)}
            style={this.applyStyle(col)}>
            <PercentComponent
              id={row.rowData[col.field] ? row.rowData[col.field].cellData : ""}
              value={
                row.rowData[col.field] ? row.rowData[col.field].cellData : ""
              }
              editable={
                row.rowData[col.field] &&
                row.rowData[col.field].cellMeta &&
                row.rowData[col.field].cellMeta.editable
              }
              onBlurData={value =>
                self.props.onCellValueChanged(value, col, row, rowIndex)
              }
            />
          </div>
        );
      case "CURRENCY_FIELD":
        return (
          <div
            onContextMenu={event =>
              self.onRowHandle(
                event,
                row,
                row.rowData[col.field].cellData,
                groupMeta,
                groupLength,
              )
            }
            className={this.getclassName(col, row)}
            style={this.applyStyle(col)}>
            <CurrencyComponent
              id={row.rowData[col.field] ? row.rowData[col.field].cellData : ""}
              value={
                row.rowData[col.field] ? row.rowData[col.field].cellData : ""
              }
              editable={
                row.rowData[col.field] &&
                row.rowData[col.field].cellMeta &&
                row.rowData[col.field].cellMeta.editable
              }
              currencyIcon={this.props.currencyIcon}
              onBlurData={value =>
                self.props.onCellValueChanged(value, col, row, rowIndex)
              }
            />
          </div>
        );
      case "SINGLE_SELECT_FIELD":
        return (
          <div
            onContextMenu={event =>
              self.onRowHandle(
                event,
                row,
                row.rowData[col.field].cellData,
                groupMeta,
                groupLength,
              )
            }
            style={this.applyStyle(col)}
            className={this.getclassName(col, row)}>
            <SingleSelectComponent
              id={row.rowData[col.field] ? row.rowData[col.field].cellData : ""}
              value={
                row.rowData[col.field] ? row.rowData[col.field].cellData : ""
              }
              editable={
                row.rowData[col.field] &&
                row.rowData[col.field].cellMeta &&
                row.rowData[col.field].cellMeta.editable
              }
              options={col.props.values}
              onChangeData={value =>
                self.props.onCellValueChanged(value, col, row, rowIndex)
              }
            />
          </div>
        );
      case "DATE_FIELD":
        return (
          <div
            onContextMenu={event =>
              self.onRowHandle(
                event,
                row,
                row.rowData[col.field].cellData,
                groupMeta,
                groupLength,
              )
            }
            className={this.getclassName(col, row)}
            style={this.applyStyle(col)}>
            <DateSelectComponent
              id={row.rowData[col.field] ? row.rowData[col.field].cellData : ""}
              value={
                row.rowData[col.field] ? row.rowData[col.field].cellData : ""
              }
              editable={
                row.rowData[col.field] &&
                row.rowData[col.field].cellMeta &&
                row.rowData[col.field].cellMeta.editable
              }
              onDateChange={value =>
                self.props.onCellValueChanged(value, col, row, rowIndex)
              }
            />
          </div>
        );
      default:
        return (
          <div
            onContextMenu={event =>
              self.onRowHandle(
                event,
                row,
                row.rowData[col.field].cellData,
                groupMeta,
                groupLength,
              )
            }
            className={this.getclassName(col, row)}
            style={this.applyStyle(col)}>
            <TextComponent
              id={row.rowData[col.field] ? row.rowData[col.field].cellData : ""}
              value={
                row.rowData[col.field] ? row.rowData[col.field].cellData : ""
              }
              editable={
                row.rowData[col.field] &&
                row.rowData[col.field].cellMeta &&
                row.rowData[col.field].cellMeta.editable
              }
              onBlurData={value =>
                self.props.onCellValueChanged(value, col, row, rowIndex)
              }
            />
          </div>
        );
    }
  };

  render() {
    const { col, row, rowIndex, colIndex, groupMeta, groupLength } = this.props;
    return (
      <Fragment>
        <ContextMenuItems
          {...this.state.popup}
          onSelectItem={this.onSelectItem}
        />
        {this.renderSwitch(
          col,
          row,
          rowIndex,
          colIndex,
          groupMeta,
          groupLength,
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/CustomGrid/RowRenderer/RowRenderer.js